import React from 'react';
import PropTypes from 'prop-types';
import {
    LineChart,
    Line
} from 'recharts';

RIQSparkLine.propTypes = {
    className: PropTypes.string,
    data: PropTypes.array.isRequired,
    options: PropTypes.object
};

const defaultSparklineWidth = 50;
const defaultSparklineHeight = 28;
const defaultSparklineColor = '#4898e5';

export default function RIQSparkLine({className, data, options}) {

    const width = _.get(options, 'width', defaultSparklineWidth);
    const height = _.get(options, 'height', defaultSparklineHeight);
    const color = _.get(options, 'color', defaultSparklineColor);

    return (
        <div className={className}>
            {_.size(data) > 1 &&
                <LineChart
                    data={data}
                    width={width}
                    height={height}>
                    <Line
                        dataKey='value'
                        stroke={color}
                        dot={false}
                        isAnimationActive={false}
                    />
                </LineChart>
            }
        </div>
    );
}
